import React from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";
import { RenderWhen, TooltipIcon } from "../../components";

type FormLabelSizeVariant = "sm" | "rg" | "lg";

interface FormLabelProps {
  label: string;
  labelSize?: FormLabelSizeVariant;
  tooltipText?: string;
  tooltipIcon?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const FormLabel = ({
  label,
  labelSize = "rg",
  tooltipText,
  tooltipIcon = "info-circle",
  required = false,
  disabled = false,
  className
}: FormLabelProps) => (
  <Form.Label
    className={clsx(
      "form-label",
      className,
      disabled && "form-label--disabled"
    )}
  >
    <span
      className={clsx(
        "form-label__text",
        `form-label__text--size-${labelSize}`
      )}
    >
      {label}
    </span>
    <RenderWhen condition={required}>
      <span className="form-label__mandatory-mark">*</span>
    </RenderWhen>
    <RenderWhen condition={!!tooltipText?.length}>
      <TooltipIcon
        icon={tooltipIcon}
        message={tooltipText || ""}
        className="form-label__tooltip-icon"
      />
    </RenderWhen>
  </Form.Label>
);

export default FormLabel;
